import React, { useEffect, useState } from 'react';
import { preferenciasNotificacionesService } from '../services/api';
import ConfirmPopup from '../components/ConfirmPopup';
import './Dashboard.css';

const NOTIFICACIONES = [
  {
    key: 'inscripcion_curso',
    label: 'Inscripciones Cursos',
    desc: 'Si se desactiva se dejará de recibir notificaciones de aceptación o rechazo de un curso.',
  },
  {
    key: 'recordatorio_tarea',
    label: 'Recordatorio Tarea',
    desc: 'Si se desactiva no recibirá notificaciones de tareas pendientes por vencer.',
  },
  {
    key: 'tarea_corregida',
    label: 'Tarea Corregida',
    desc: 'Si se desactiva no recibirá notificación al recibir corrección en sus tareas.',
  },
  {
    key: 'certificado',
    label: 'Certificado',
    desc: 'Si se desactiva no recibirá notificación cuando se genere su certificado.',
  },
];

const MiConfiguracion = () => {
  const [prefs, setPrefs] = useState({
    inscripcion_curso: true,
    recordatorio_tarea: true,
    tarea_corregida: true,
    certificado: true,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    let cancelled = false;
    preferenciasNotificacionesService
      .get()
      .then((data) => {
        if (!cancelled) {
          setPrefs({
            inscripcion_curso: !!data.inscripcion_curso,
            recordatorio_tarea: !!data.recordatorio_tarea,
            tarea_corregida: !!data.tarea_corregida,
            certificado: !!data.certificado,
          });
        }
      })
      .catch(() => {
        if (!cancelled) setMessage({ type: 'error', text: 'No se pudieron cargar las preferencias.' });
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const handleChange = async (key, checked) => {
    const nuevo = { ...prefs, [key]: checked };
    setPrefs(nuevo);
    setSaving(true);
    setMessage({ type: '', text: '' });
    try {
      await preferenciasNotificacionesService.update({ [key]: checked });
      setMessage({ type: 'success', text: 'Preferencias guardadas.' });
    } catch {
      setPrefs(prefs);
      setMessage({ type: 'error', text: 'No se pudo guardar. Intente de nuevo.' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-header">
        <h1>Mi configuración</h1>
        <p>Cargando preferencias…</p>
      </div>
    );
  }

  return (
    <>
      <ConfirmPopup
        open={Boolean(message.text) && message.type === 'error'}
        title="Error"
        message={message.text}
        confirmLabel="Aceptar"
        cancelLabel={null}
        onConfirm={() => setMessage({ type: '', text: '' })}
        onCancel={() => setMessage({ type: '', text: '' })}
        variant="danger"
      />
      <div className="dashboard-header">
        <h1>Mi configuración</h1>
        <p>Setea tus preferencias de configuración del campus.</p>
      </div>
      {message.text && message.type !== 'error' && (
        <div className="alert alert-success" role="status">
          {message.text}
        </div>
      )}
      <section className="dashboard-section">
        <h2 className="dashboard-section-title">Notificaciones por correo</h2>
        <p>Activa o desactiva las notificaciones que deseas recibir por correo. Por defecto están activas.</p>
        <div className="mi-configuracion-list">
          {NOTIFICACIONES.map(({ key, label, desc }) => (
            <div key={key} className="mi-configuracion-item">
              <label className="mi-configuracion-label">
                <input
                  type="checkbox"
                  checked={!!prefs[key]}
                  onChange={(e) => handleChange(key, e.target.checked)}
                  disabled={saving}
                  className="mi-configuracion-checkbox"
                />
                <span className="mi-configuracion-label-text">{label}</span>
              </label>
              <p className="mi-configuracion-desc">{desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default MiConfiguracion;
